import { NativeModulesProxy } from 'expo-modules-core';

import { NotificationCategoriesModule } from './NotificationCategoriesModule.types';

export default NativeModulesProxy.ExpoNotificationCategoriesModule as NotificationCategoriesModule;
